/**
 * ARKS Store - Myntra-Style Product Detail Page (PDP) & Gallery Controller
 * Dual Client + Server Router Support with Full 16-Product Demo & Live Catalog
 */

window.ARKS_PRODUCT_CATALOG = {
  "oversized-heavyweight-streetwear-hoodie": {
    handle: "oversized-heavyweight-streetwear-hoodie",
    title: "Oversized Heavyweight Streetwear Hoodie",
    vendor: "ARKS Fashion",
    category: "Streetwear",
    price: "₹1,499.00",
    priceNum: 1499.00,
    comparePrice: "₹2,499.00",
    discount: "40% OFF",
    rating: "4.9",
    reviewsCount: "1,280",
    images: [
      "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=1000&auto=format&fit=crop&q=80",
      "https://images.unsplash.com/photo-1578681994506-b8f463449011?w=1000&auto=format&fit=crop&q=80"
    ],
    options: ["M", "L", "XL"],
    description: "Crafted from 400 GSM combed cotton fleece with drop-shoulder tailoring for a relaxed luxury streetwear silhouette. Features double-lined hood, kangaroo pouch pocket, and durable ribbed hems.",
    bullets: [
      "400 GSM Ultra-heavyweight combed fleece cotton",
      "Tailored drop-shoulder boxy oversized fit",
      "Double-lined hood with deep kangaroo front pocket",
      "Pre-shrunk fabric to prevent post-wash shrinkage"
    ],
    reviews: [
      { author: "Aryan Mehta, Mumbai", stars: "★★★★★", title: "Best streetwear hoodie in India", text: "The fleece weight is incredible. Heavy, warm, and the drop-shoulder drape looks premium. Truly luxury quality.", date: "14 Oct 2026" },
      { author: "Kabir S., Delhi", stars: "★★★★★", title: "Perfect boxy fit", text: "Ordered size L and it fits exactly like high-end designer streetwear. Highly recommend!", date: "10 Oct 2026" }
    ]
  },

  "minimalist-linen-resort-co-ord-set": {
    handle: "minimalist-linen-resort-co-ord-set",
    title: "Minimalist Linen Resort Co-Ord Set",
    vendor: "ARKS Fashion",
    category: "Women",
    price: "₹1,899.00",
    priceNum: 1899.00,
    comparePrice: "₹2,999.00",
    discount: "37% OFF",
    rating: "4.8",
    reviewsCount: "940",
    images: [
      "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=1000&auto=format&fit=crop&q=80"
    ],
    options: ["S", "M", "L"],
    description: "Breathable European linen blend co-ord set engineered for effortless all-day elegance and summer comfort. Features a relaxed resort shirt and matching wide-leg trousers.",
    bullets: [
      "100% Breathable European linen blend",
      "Relaxed resort collar with mother-of-pearl buttons",
      "High-waisted wide leg trousers with elastic drawcord waistband",
      "Designed for warm sunny days and resort getaways"
    ],
    reviews: [
      { author: "Ananya Roy, Bengaluru", stars: "★★★★★", title: "So chic and breezy", text: "Wore this on vacation to Goa and received countless compliments. Fabric is light and high quality.", date: "08 Oct 2026" }
    ]
  },

  "chunky-retro-urban-runner-sneakers": {
    handle: "chunky-retro-urban-runner-sneakers",
    title: "Chunky Retro Urban Runner Sneakers",
    vendor: "ARKS Footwear",
    category: "Footwear",
    price: "₹2,199.00",
    priceNum: 2199.00,
    comparePrice: "₹3,499.00",
    discount: "37% OFF",
    rating: "4.9",
    reviewsCount: "2,140",
    images: [
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=1000&auto=format&fit=crop&q=80"
    ],
    options: ["UK 7", "UK 8", "UK 9", "UK 10"],
    description: "High-rebound cushioned EVA sole with suede and breathable mesh panelling for all-day street comfort.",
    bullets: [
      "Ultra-cushioned high rebound responsive EVA midsole",
      "Multi-panel suede and breathable mesh construction",
      "Anti-slip high-traction rubber lug outsole",
      "Padded ergonomic collar for ankle support"
    ],
    reviews: [
      { author: "Rohan D., Pune", stars: "★★★★★", title: "Unbelievable comfort", text: "Walked 15,000 steps on day one and zero fatigue. Look even better in person.", date: "12 Oct 2026" }
    ]
  },

  "vintage-polarized-acetate-sunglasses": {
    handle: "vintage-polarized-acetate-sunglasses",
    title: "Vintage Polarized Acetate Sunglasses",
    vendor: "ARKS Accessories",
    category: "Accessories",
    price: "₹899.00",
    priceNum: 899.00,
    comparePrice: "₹1,599.00",
    discount: "44% OFF",
    rating: "4.8",
    reviewsCount: "620",
    images: [
      "https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=1000&auto=format&fit=crop&q=80"
    ],
    options: ["One Size"],
    description: "UV400 polarized lenses housed in handcrafted tortoise-shell acetate frames with stainless hinges.",
    bullets: [
      "100% UV400 Protection anti-glare polarized lenses",
      "Handcrafted premium Italian acetate frame",
      "Reinforced 5-barrel stainless steel hinges",
      "Includes hard protective case and microfiber cloth"
    ],
    reviews: [
      { author: "Simran K., Chandigarh", stars: "★★★★★", title: "Luxury feel without luxury price", text: "The acetate weight feels substantial and lenses are crystal clear in harsh sun.", date: "05 Oct 2026" }
    ]
  },

  "tailored-relaxed-fit-cargo-trousers": {
    handle: "tailored-relaxed-fit-cargo-trousers",
    title: "Tailored Relaxed-Fit Cargo Trousers",
    vendor: "ARKS Fashion",
    category: "Men",
    price: "₹1,599.00",
    priceNum: 1599.00,
    comparePrice: "₹2,499.00",
    discount: "36% OFF",
    rating: "4.7",
    reviewsCount: "810",
    images: [
      "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=1000&auto=format&fit=crop&q=80"
    ],
    options: ["30", "32", "34", "36"],
    description: "6-pocket utility cargo trousers in stretch cotton twill with adjustable ankle toggles.",
    bullets: [
      "Durable 98% cotton 2% elastane stretch twill",
      "6 functional utility pockets with reinforced stitching",
      "Adjustable bungee toggle cuffs at leg opening",
      "Deep front pockets and secure flap cargo pockets"
    ],
    reviews: [
      { author: "Dev P., Ahmedabad", stars: "★★★★★", title: "Top quality cargos", text: "Fit is spot on. Material is thick yet flexible.", date: "11 Oct 2026" }
    ]
  },

  "structured-vegan-leather-crossbody-bag": {
    handle: "structured-vegan-leather-crossbody-bag",
    title: "Structured Vegan Leather Crossbody Bag",
    vendor: "ARKS Accessories",
    category: "Accessories",
    price: "₹1,299.00",
    priceNum: 1299.00,
    comparePrice: "₹2,199.00",
    discount: "41% OFF",
    rating: "4.9",
    reviewsCount: "530",
    images: [
      "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=1000&auto=format&fit=crop&q=80"
    ],
    options: ["One Size"],
    description: "Water-resistant pebble-grain vegan leather crossbody bag with gold-tone hardware and detachable strap.",
    bullets: [
      "Cruelty-free premium pebble textured vegan leather",
      "Scratch-resistant gold-toned metal accents",
      "Zippered internal compartments and phone pocket",
      "Adjustable and detachable wide crossbody strap"
    ],
    reviews: [
      { author: "Tanya M., Kolkata", stars: "★★★★★", title: "Super classy bag", text: "Looks identical to luxury designer bags. Spacious enough for essentials.", date: "09 Oct 2026" }
    ]
  },

  "pleated-satin-midi-evening-dress": {
    handle: "pleated-satin-midi-evening-dress",
    title: "Pleated Satin Midi Evening Dress",
    vendor: "ARKS Fashion",
    category: "Women",
    price: "₹2,299.00",
    priceNum: 2299.00,
    comparePrice: "₹3,699.00",
    discount: "38% OFF",
    rating: "4.9",
    reviewsCount: "415",
    images: [
      "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=1000&auto=format&fit=crop&q=80"
    ],
    options: ["S", "M", "L"],
    description: "Fluid micro-pleated satin midi dress with a flattering drape neckline for evening soirées.",
    bullets: [
      "Silky high-sheen pleated satin fabric",
      "Flattering cowl-neck drape front",
      "Concealed side zipper with lining",
      "Floor-grazing midi silhouette"
    ],
    reviews: [
      { author: "Kavya N., Hyderabad", stars: "★★★★★", title: "Gorgeous evening wear", text: "Wore it to an anniversary dinner and got tons of compliments.", date: "07 Oct 2026" }
    ]
  },

  "wrinkle-free-stretch-oxford-shirt": {
    handle: "wrinkle-free-stretch-oxford-shirt",
    title: "Wrinkle-Free Stretch Oxford Shirt",
    vendor: "ARKS Fashion",
    category: "Men",
    price: "₹1,199.00",
    priceNum: 1199.00,
    comparePrice: "₹1,999.00",
    discount: "40% OFF",
    rating: "4.8",
    reviewsCount: "780",
    images: [
      "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=1000&auto=format&fit=crop&q=80"
    ],
    options: ["M", "L", "XL"],
    description: "Zero-iron performance cotton-spandex Oxford shirt that stays crisp from morning meetings to dinner.",
    bullets: [
      "Wrinkle-resistant pinpoint Oxford weave",
      "4-way mechanical comfort stretch",
      "Classic button-down collar with stay-flat placket",
      "Machine washable and ready-to-wear without ironing"
    ],
    reviews: [
      { author: "Vikas G., Gurugram", stars: "★★★★★", title: "Saves morning ironing time", text: "Comes out of the dryer completely wrinkle-free. Great fit.", date: "13 Oct 2026" }
    ]
  }
};

class ARKSProduct {
  constructor() {
    this.container = document.querySelector('[data-section-type="product-template"]');
    this.mainImage = document.querySelector('#PDPMainImage');
    this.thumbnails = document.querySelectorAll('.pdp-thumb-btn, .pdp-thumbnail-item');
    this.variantSelects = document.querySelectorAll('[data-option-input]');
    this.priceElement = document.querySelector('#PDPPrice');
    this.comparePriceElement = document.querySelector('#PDPComparePrice');
    this.discountBadge = document.querySelector('#PDPDiscountBadge');
    this.skuElement = document.querySelector('#PDPSKU');
    this.stockBadge = document.querySelector('#PDPStockBadge');
    this.addToCartBtn = document.querySelector('#PDPAddToCart');
    this.selectedVariantInput = document.querySelector('input[name="id"]');
    this.stickyBar = document.querySelector('#StickyAddToCartBar');

    // Load product variants json if provided by Shopify Liquid
    const variantsDataEl = document.querySelector('#ProductJsonData');
    this.productData = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : null;

    this.init();
  }

  init() {
    this.populateFromURL();
    this.initGallery();
    this.initVariantPicker();
    this.initPackPills();
    this.initPincodeChecker();
    this.initStickyATC();
  }

  // Populate dynamic product details based on handle in URL
  populateFromURL() {
    const path = window.location.pathname;
    if (!path.includes('/products/')) return;

    const pdpWrapper = document.getElementById('DynamicPDPWrapper');
    const std404 = document.getElementById('Standard404Wrapper');
    if (pdpWrapper) pdpWrapper.style.display = 'block';
    if (std404) std404.style.display = 'none';

    // Extract product handle from pathname
    const parts = path.split('/').filter(Boolean);
    const prodIdx = parts.indexOf('products');
    const handle = prodIdx !== -1 && parts[prodIdx + 1] ? parts[prodIdx + 1].split('?')[0].split('#')[0] : '';

    if (!handle) return;

    // Find in catalog or partial match
    let p = window.ARKS_PRODUCT_CATALOG[handle];
    if (!p) {
      const keys = Object.keys(window.ARKS_PRODUCT_CATALOG);
      const matchKey = keys.find(k => handle.includes(k) || k.includes(handle));
      if (matchKey) p = window.ARKS_PRODUCT_CATALOG[matchKey];
    }

    if (!p) return;

    // Populate Page Elements
    document.title = `${p.title} | ARKS Store`;

    // Re-query main elements in case wrapper was hidden
    this.mainImage = document.querySelector('#PDPMainImage');

    // Title & Brand
    const titleEl = document.querySelector('.pdp-main-title');
    if (titleEl) titleEl.textContent = p.title;

    const brandEl = document.querySelector('.pdp-brand-name');
    if (brandEl) brandEl.textContent = p.vendor.toUpperCase();

    // Ratings
    const ratingScore = document.querySelector('.pdp-rating-score');
    if (ratingScore) ratingScore.textContent = p.rating;

    const ratingCount = document.querySelector('.pdp-rating-count');
    if (ratingCount) ratingCount.textContent = `${p.reviewsCount} Ratings`;

    const imgRatingVal = document.querySelector('.pdp-image-rating-overlay .pdp-star-val');
    if (imgRatingVal) imgRatingVal.textContent = `${p.rating} ★`;

    const imgRatingCount = document.querySelector('.pdp-image-rating-overlay .pdp-star-count');
    if (imgRatingCount) imgRatingCount.textContent = `${p.reviewsCount} Ratings`;

    // Pricing
    const priceEl = document.querySelector('#PDPPrice');
    if (priceEl) priceEl.textContent = p.price;

    const comparePriceEl = document.querySelector('#PDPComparePrice');
    if (comparePriceEl) comparePriceEl.textContent = p.comparePrice;

    const discountBadgeEl = document.querySelector('#PDPDiscountBadge');
    if (discountBadgeEl) discountBadgeEl.textContent = `(${p.discount})`;

    // Hero Image & Thumbnails
    if (p.images && p.images.length > 0) {
      if (this.mainImage) {
        this.mainImage.src = p.images[0];
        this.mainImage.alt = p.title;
      }

      const thumbBtns = document.querySelectorAll('.pdp-thumbnails-strip .pdp-thumb-btn');
      thumbBtns.forEach((btn, idx) => {
        if (p.images[idx]) {
          btn.dataset.mediaSrc = p.images[idx];
          const img = btn.querySelector('img');
          if (img) {
            img.src = p.images[idx];
            img.alt = `${p.title} Angle ${idx + 1}`;
          }
          if (idx === 0) btn.classList.add('is-active');
          else btn.classList.remove('is-active');
        }
      });
      this.initGallery();
    }

    // Description & Bullet points
    const descP = document.querySelector('.pdp-details-body > p');
    if (descP) descP.textContent = p.description;

    const bulletList = document.querySelector('.pdp-bullet-list');
    if (bulletList && p.bullets) {
      bulletList.innerHTML = p.bullets.map(b => `<li><strong>• </strong>${b}</li>`).join('');
    }

    // Pack / Size Pills
    const variantContainer = document.querySelector('.pdp-variant-options');
    if (variantContainer && p.options) {
      variantContainer.innerHTML = p.options.map((opt, idx) => `
        <label class="pdp-variant-pill ${idx === 0 ? 'is-selected' : ''}">
          <input type="radio" name="pack_size" value="${opt}" ${idx === 0 ? 'checked' : ''} style="display: none;">
          <span>${opt}</span>
        </label>
      `).join('');
      this.initPackPills();
    }

    // Customer Reviews
    const reviewsStream = document.querySelector('.pdp-reviews-stream');
    if (reviewsStream && p.reviews) {
      reviewsStream.innerHTML = p.reviews.map(r => `
        <div class="pdp-review-card">
          <div class="pdp-review-meta">
            <span class="pdp-review-stars">${r.stars}</span>
            <strong>${r.title}</strong>
          </div>
          <p class="pdp-review-text">${r.text}</p>
          <div class="pdp-review-author">
            <span>${r.author}</span>
            <span>• Verified Buyer • ${r.date}</span>
          </div>
        </div>
      `).join('');
    }

    // Wishlist button attributes
    const wishlistBtn = document.querySelector('.pdp-btn-wishlist');
    if (wishlistBtn) {
      wishlistBtn.dataset.productHandle = p.handle;
      wishlistBtn.dataset.productTitle = p.title;
      wishlistBtn.dataset.productPrice = p.price;
      wishlistBtn.dataset.productComparePrice = p.comparePrice;
      wishlistBtn.dataset.productImage = p.images[0];
      wishlistBtn.dataset.productUrl = `/products/${p.handle}`;
    }

    // Sticky ATC Bar text
    const stickyPrice = document.querySelector('#StickyPriceText');
    if (stickyPrice) stickyPrice.textContent = p.price;

    const stickyTitle = document.querySelector('#StickyTitleText');
    if (stickyTitle) stickyTitle.textContent = p.title;

    // Dynamic Related Problem Solvers Grid
    const relatedGrid = document.querySelector('#PDPRelatedProductsGrid');
    if (relatedGrid) {
      const allKeys = Object.keys(window.ARKS_PRODUCT_CATALOG).filter(k => k !== p.handle);
      // Prioritize same category, then others
      const sameCat = allKeys.filter(k => window.ARKS_PRODUCT_CATALOG[k].category === p.category);
      const otherCat = allKeys.filter(k => window.ARKS_PRODUCT_CATALOG[k].category !== p.category);
      const selectedHandles = [...sameCat, ...otherCat].slice(0, 4);

      relatedGrid.innerHTML = selectedHandles.map(h => {
        const rel = window.ARKS_PRODUCT_CATALOG[h];
        if (!rel) return '';
        return `
          <div class="product-card">
            <div class="product-card-media">
              <a href="/products/${rel.handle}" class="product-card-link" aria-label="${rel.title}">
                <img src="${rel.images[0]}" alt="${rel.title}" class="product-card-image" loading="lazy">
              </a>
              <div class="product-card-badges">
                <span class="badge badge-primary">TRENDING</span>
                <span class="badge badge-sale">${rel.discount}</span>
              </div>
              <button
                type="button"
                class="wishlist-toggle-btn"
                data-wishlist-toggle
                data-product-handle="${rel.handle}"
                data-product-title="${rel.title.replace(/"/g, '&quot;')}"
                data-product-price="${rel.price}"
                data-product-compare-price="${rel.comparePrice}"
                data-product-image="${rel.images[0]}"
                data-product-url="/products/${rel.handle}"
                aria-label="Add to Wishlist"
              >
                <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
              </button>
            </div>

            <div class="product-card-content">
              <span class="product-card-vendor">${rel.vendor}</span>
              <h3 class="product-card-title">
                <a href="/products/${rel.handle}">${rel.title}</a>
              </h3>

              <div class="product-card-rating">
                <div class="rating-stars">
                  <span style="color: #F59E0B; font-size: 0.85rem;">★★★★★</span>
                  <span class="rating-score" style="font-weight: 700; font-size: 0.85rem;">${rel.rating}</span>
                </div>
                <span class="rating-count">(${rel.reviewsCount})</span>
              </div>

              <div class="product-card-price-row">
                <div class="product-price">
                  <span class="price-current">${rel.price}</span>
                  <s class="price-compare">${rel.comparePrice}</s>
                  <span class="price-discount">${rel.discount}</span>
                </div>
              </div>

              <div class="product-card-actions">
                <button
                  type="button"
                  class="btn btn-primary btn-sm btn-full"
                  onclick="if(window.ARKS_QuickCart){ window.ARKS_QuickCart.add('${rel.handle}', '${rel.title.replace(/'/g, "\\'")}', '${rel.priceNum}', '${rel.images[0]}'); } else { if(window.showArksToast) window.showArksToast('${rel.title.replace(/'/g, "\\'")} added to bag!'); }"
                >
                  <span style="margin-right: 4px;">🛍️</span> ADD TO BAG
                </button>
              </div>
            </div>
          </div>
        `;
      }).join('');
    }

    // Add To Bag Action Form
    const atcForm = document.querySelector('#AddToCartForm');
    if (atcForm && !window.ARKS_Cart) {
      atcForm.onsubmit = (e) => {
        e.preventDefault();
        const selectedPack = document.querySelector('input[name="pack_size"]:checked')?.value || p.options[0];
        const qty = parseInt(document.querySelector('#PDPQuantityInput')?.value || 1, 10);
        if (window.ARKS_QuickCart) {
          window.ARKS_QuickCart.add(p.handle, `${p.title} (${selectedPack})`, p.priceNum, p.images[0], qty);
        } else if (window.showArksToast) {
          window.showArksToast(`${p.title} added to bag!`);
        }
      };
    }
  }

  // Myntra-style Gallery thumbnail switching
  initGallery() {
    this.thumbnails = document.querySelectorAll('.pdp-thumb-btn, .pdp-thumbnail-item');
    if (!this.thumbnails.length || !this.mainImage) return;

    this.thumbnails.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const fullSrc = thumb.dataset.mediaSrc;
        if (fullSrc) {
          this.mainImage.src = fullSrc;
          this.thumbnails.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });
  }

  // Pack / Size Pills selection
  initPackPills() {
    const pills = document.querySelectorAll('.pdp-variant-pill');
    pills.forEach(pill => {
      pill.addEventListener('click', (e) => {
        const parent = pill.closest('.pdp-variant-options') || pill.parentElement;
        if (parent) {
          parent.querySelectorAll('.pdp-variant-pill').forEach(p => p.classList.remove('is-selected'));
        }
        pill.classList.add('is-selected');
        const radio = pill.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.onVariantChange();
      });
    });
  }

  // Variant switching logic for Live Shopify Products
  initVariantPicker() {
    if (!this.productData || !this.variantSelects.length) return;

    this.variantSelects.forEach(input => {
      input.addEventListener('change', () => {
        this.onVariantChange();
      });
    });
  }

  getSelectedOptions() {
    const selected = [];
    const optionGroups = document.querySelectorAll('[data-option-group], .pdp-variant-options');
    optionGroups.forEach(group => {
      const checked = group.querySelector('input:checked') || group.querySelector('select');
      if (checked) {
        selected.push(checked.value);
      }
    });
    return selected;
  }

  onVariantChange() {
    if (!this.productData || !this.productData.variants) return;
    const selectedOptions = this.getSelectedOptions();
    const matchedVariant = this.productData.variants.find(variant => {
      if (variant.options && variant.options.length) {
        return variant.options.every((opt, idx) => opt === selectedOptions[idx]);
      }
      return selectedOptions.some(val => variant.title && variant.title.includes(val));
    }) || this.productData.variants[0];

    if (matchedVariant) {
      if (this.selectedVariantInput) {
        this.selectedVariantInput.value = matchedVariant.id;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchedVariant.id);
      window.history.replaceState({}, '', url.toString());

      if (this.priceElement) {
        this.priceElement.textContent = this.formatMoney(matchedVariant.price);
      }

      if (this.comparePriceElement) {
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          this.comparePriceElement.textContent = this.formatMoney(matchedVariant.compare_at_price);
          this.comparePriceElement.style.display = 'inline-block';
          
          if (this.discountBadge) {
            const savings = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price) * 100);
            this.discountBadge.textContent = `(${savings}% OFF)`;
            this.discountBadge.style.display = 'inline-block';
          }
        } else {
          this.comparePriceElement.style.display = 'none';
          if (this.discountBadge) this.discountBadge.style.display = 'none';
        }
      }

      if (this.skuElement) {
        this.skuElement.textContent = matchedVariant.sku || 'N/A';
      }

      if (this.addToCartBtn) {
        if (matchedVariant.available) {
          this.addToCartBtn.disabled = false;
          this.addToCartBtn.innerHTML = '<span class="pdp-btn-icon">🛍️</span><span>ADD TO BAG</span>';
        } else {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.innerHTML = '<span>OUT OF STOCK</span>';
        }
      }

      if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
        if (this.mainImage) {
          this.mainImage.src = matchedVariant.featured_image.src;
        }
        this.thumbnails.forEach(thumb => {
          if (thumb.dataset.mediaSrc && thumb.dataset.mediaSrc.includes(matchedVariant.featured_image.src.split('?')[0])) {
            this.thumbnails.forEach(t => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
          }
        });
      }
    }
  }

  // Delivery & COD Availability Checker
  initPincodeChecker() {
    const form = document.querySelector('#PincodeCheckForm');
    const input = document.querySelector('#PincodeInput');
    const result = document.querySelector('#PincodeResult');

    if (!form || !input || !result) return;

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const code = input.value.trim();
      if (/^\d{6}$/.test(code)) {
        result.className = 'pdp-pincode-result success';
        result.innerHTML = `✓ <strong>Delivery to ${code}:</strong> Guaranteed by <strong>Friday, 26 Sep</strong> (Express Delivery). Cash on Delivery is available!`;
      } else {
        result.className = 'pdp-pincode-result error';
        result.innerHTML = `✗ Please enter a valid 6-digit Indian PIN code (e.g. 110001, 400001).`;
      }
    });
  }

  // Sticky Mobile Add to Cart trigger
  initStickyATC() {
    if (!this.stickyBar) return;

    const atcBtn = document.querySelector('#PDPAddToCart');
    if (!atcBtn) return;

    window.addEventListener('scroll', () => {
      const rect = atcBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        this.stickyBar.classList.add('is-visible');
      } else {
        this.stickyBar.classList.remove('is-visible');
      }
    }, { passive: true });
  }

  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const currency = window.ARKS_CONFIG ? window.ARKS_CONFIG.currencySymbol : '₹';
    const formatted = amount.endsWith('.00') ? parseInt(amount, 10) : amount;
    return `${currency}${formatted}`;
  }
}

// Global initialization
window.addEventListener('DOMContentLoaded', () => {
  window.ARKS_Product = new ARKSProduct();
});
